module.exports = "/_next/static/images/hand-monotone-68ee3f05c5ae8ea1c7b8fc4dfe60220b.svg";